// Types
import type { PatternName } from '@/types/utils/get-pattern'

// Get pattern
const GetPattern = (name: PatternName, min?: number, max?: number) => {
	let output = ''

	if (name === 'name') output = `(?=.{${min},${max}}$)([A-Za-z]+(?:[-'][A-Za-z]+)?(?: [A-Za-z]+(?:[-'][A-Za-z]+)?)*)`
	else if (name === 'email') output = '[a-zA-Z0-9\\._\\-]+@[a-zA-Z0-9\\.\\-]+\\.[a-z]{2,4}'
	else if (name === 'password') output = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\[-`{-~]).'
	else if (name === 'mobile') output = '09[0-9]{9}'
	else if (name === 'digit') output = '[0-9]{1}'
	else if (name === 'alias') output = '[a-zA-Z0-9\\-]'

	return ['name', 'email', 'mobile', 'digit'].includes(name) ? `^${output}$` : `^${output}${min || max ? `{${min ?? ''},${max ?? ''}}` : '*'}$`
}

export default GetPattern
